<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="98">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="投保公司">
                            <Input v-model.trim="params.applicantInfo" clearable placeholder="请输入投保公司" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批单编号">
                            <Input v-model.trim="params.endorseNo" clearable placeholder="请输入批单编号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="关联保单号">
                            <Input v-model.trim="params.cntrNo" clearable placeholder="请输入关联保单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批单状态">
                            <Select v-model="params.endorseStatus" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/broker/insurance/endorse/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <Dropdown transfer>
                        <a href="javascript:void(0)">
                            管理
                            <Icon type="ios-arrow-down"></Icon>
                        </a>
                        <Dropdown-menu slot="list">
                            <Dropdown-item @click.native="toDetail(row)" style="text-align: center;">
                                <a>查看详情</a>
                            </Dropdown-item>
                            <Dropdown-item  v-if="(row.endorseStatus=='UNCONFIRMED'||row.endorseStatus=='REVIEWED_REJECTED'||row.endorseStatus=='REJECTED'||row.endorseStatus=='CONFIRMED')"  @click.native="toEdit(row)" style="text-align: center;">
                                <!-- 待确认 核保失败 已拒保 已确认 -->
                                <a>编辑</a>
                            </Dropdown-item>
                            <Dropdown-item  v-if="row.electronicEndorseUrl">
                                <a :href="row.electronicEndorseUrl" target="_blank">下载电子批单</a>
                            </Dropdown-item>
                        </Dropdown-menu>
                    </Dropdown>
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import ITable from '../../../companyGroupEmployerDadi/common/ITable'
    export default {
        components:{ ITable },
        data () {
            return {
                loading: false,
                params: {
                    bizId:'INDUSTRY_ENTERPRISE'
                },
                columns: [
                    {title:'批单编号',key:'endorseNo',width: 260,fixed: 'left'},
                    {title:'关联保单号',key:'cntrNo',width: 260},
                    {title:'批单创建时间',key:'createTime',width: 180},
                    {title:'投保公司名称',key:'applicantName',width: 180,ellipsis: true,tooltip: true},
                    {title:'产品名称',key:'productName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'保险公司',key:'insuranceCompanyName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'批单状态',key:'endorseStatusDesc',width: 120},
                    {title:'批单保费（元）',key:'premium',width: 140,align: 'right'},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 90,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: 'UNCONFIRMED',
                        label: '待确认'
                    },
                    {
                        value: 'CONFIRMED',
                        label: '已确认'
                    },
                    {
                        value: 'REVIEWING',
                        label: '核保中'
                    },
                    {
                        value: 'REVIEWED_REJECTED',
                        label: '核保失败'
                    },
                    {
                        value: 'ENDORSE_ISSUING',
                        label: '批改出单中'
                    },
                    {
                        value: 'FINISHED',
                        label: '已完成'
                    },
                    {
                        value: 'REJECTED',
                        label: '已拒保'
                    }
                ]
            }
        },
        computed:{
            ...mapState({
                channelId: state=>state.common.channelInfo.id,
            })
        },
        created () {
            // this.getList()
        },
        methods:{
            tabChange(){
                this.$refs.table.getList()
            },
            toRest (row) {
                this.$axios.post('/broker/insurance/endorse/preCheck.all',{
                    insurancePolicyId: row.insurancePolicyId
                }).then(res=>{
                    if(res.code==10000000){
                        this.$router.push(`/companyGroupEmployerDadi/edit/${row.insurancePolicyId}`)
                    }
                });
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedCCIC/riderDetail/${row.endorseNo}`
                })
            },
            toEdit(row){
                this.$axios.post('/broker/insurance/endorse/preCheck.all',{
                    insurancePolicyId: row.insurancePolicyId
                }).then(res=>{
                    if(res.code==10000000){
                        this.$router.push({
                            path:`/companyGroupEmployerDadi/edit/${row.insurancePolicyId}?reset=NEW&endorseNo=${row.endorseNo}`
                        })
                    } else {
                        this.$Modal.confirm({
                            title: res.msg,
                            onOk: () => {
                                this.$router.push({
                                    path:`/companyGroupEmployerDadi/edit/${row.insurancePolicyId}?reset=NEW&endorseNo=${row.endorseNo}`
                                })
                            },
                            onCancel: () => {
                            }
                        });
                    }
                })
            }
        }
    }
</script>
<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedDadi/rider/index.vue